export default __webpack_public_path__ + "static/media/IU_Home3.48c32cb2.jpg";